import { motion } from "framer-motion";
import { memo } from "react";
import { useLocation } from "react-router-dom";

function MotionContainer({
	children,
	scroll = false,
	animationKey,
}: {
	children: React.ReactNode;
	scroll?: boolean;
	animationKey?: string;
}) {
	const location = useLocation().pathname;
	const key = animationKey ?? location;
	return (
		<motion.div
			key={key}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
			style={{
				display: "flex",
				flexDirection: "column",
				flex: 1,
				...(scroll
					? { overflowYY: "auto" }
					: { maxHeight: "100%", overflow: "hidden" }),
			}}
		>
			{children}
		</motion.div>
	);
}

export default memo(MotionContainer);
